module.exports = __webpack_public_path__ + "site/img/20.515a14dc.jpg";